<template>
  <RequestWizardStep name="Welcome">
    <ContentCard
      title="Welcome to the FOIA request portal for Health Resources and Services Administration!"
    >
      <p>
        Please take a moment to review the records in the
        <a href="https://www.hrsa.gov/foia/electronic-reading">HRSA Reading Room</a>
        to determine if the records you might be requesting have already been published.
      </p>

      <p>
        If the records you are seeking have not already been published, please use the "Next" button
        below to begin your FOIA request.
      </p>

      <p>
        If you have already submitted a request and would like to check its progress, please access
        the <router-link to="/check-status">HRSA FOIA Status Check</router-link>.
      </p>
    </ContentCard>
  </RequestWizardStep>
</template>

<script>
import RequestWizardStep from '@/components/requestWizard/RequestWizardStep';

export default {
  components: { RequestWizardStep }
};
</script>
